// state
const state = {
  crsData: {
    nameInput: '',
    birthDate: '',
    address: '',
    cellNo: '',
    amRsdpeAll: '',
    amRsdpe1: '',
    amRsdpe2: '',
    amRsdpe3: '',
    ovseRsdpe: '',
    cancel: '',
    nameInputEng: '',
    firstName: '',
    lastName: '',
    nowAddress: '',
    rsdncNatl: '',
    paymentNum: '',
    reasonWrite: '',
    reasonWrite02: '',
  },
  currentDate: '',
  acntInf: {
    dporBdt: '',
    rlhrAcntAttrYn: '',
    idfNo: '',
    th3pedporNm: '',
    polhdRelNm: '',
    fncInstCdNm: '',
    regRefNoEncry: '',
    bankNm: '',
    rlhrTrsYn: '',
    atTrsCoVo: {},
    // 마지막 화면에서 필요.
    inempYn: '',
  },
  payAcntInf: {},
  imageData: [],
  agrInf: {},
  sgnTrnsFlag: false,
  cmpltSalCompFlag: false,
  // 대면정보
  cfntInf: {
    cfntDscMd: '',
    cfntDscPlc: '',
    inspeCfntDscMd: '',
    inspeCfntDscPlc: '',
  },
}

// mutations
const mutations = {
  changeAcntInf(state, payload) {
    console.log(payload)
    state.acntInf = { ...state.acntInf, ...payload }
  },

  changeCrsData(state, payload) {
    console.log(payload)
    state.crsData = { ...state.crsData, ...payload }
  },

  changeAgrInf(state, payload) {
    console.log(payload)
    state.agrInf = { ...state.agrInf, ...payload }
  },

  pushImageData(state, payload) {
    console.log(payload)
    // state.imageData = _.without(state.imageData, state.imageData, {ctnsKdCd: payload[0].ctnsKdCd})
    if (payload[0].ctnsKdCd == '100740') {
      _.remove(state.imageData, (d) => {
        return (
          d.ctnsKdCd == payload[0].ctnsKdCd &&
          d.atcFileNm
            .split('/')
            .pop()
            .split('_')[0] ==
            payload[0].atcFileNm
              .split('/')
              .pop()
              .split('_')[0]
        )
      })
    } else {
      _.remove(state.imageData, { ctnsKdCd: payload[0].ctnsKdCd })
    }
    state.imageData = _.unionBy(state.imageData, payload, (e) => e.imageData)
  },

  clearImageData(state) {
    state.imageData = []
  },

  changeSgnTrnsFlag(state, flag) {
    state.sgnTrnsFlag = flag
  },

  changeCmpltSalCompFlag(state, flag) {
    state.cmpltSalCompFlag = flag
  },

  changePayAcntInf(state, payload) {
    state.payAcntInf = { ...state.payAcntInf, ...payload }
  },

  changeCfntInf(state, payload) {
    state.cfntInf = { ...state.cfntInf, ...payload }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
